// Production Config
let config = {
  version: "0.2.8",
  title: `Power Pack`,
  id: `powerPack`,
  environment: "prod",
  features: {
    proToggle: false,
    buyPro: false,
    uatToggle: false,
  },

  licenseAutoCheck: true,
  miroCallTimeoutMs: 2000,

  // Miro API Auth
  refractiveApiPrefix: `https://us-central1-licenses-refractive.cloudfunctions.net/`,

  firebase: {
    apiKey: "AIzaSyBavWRdqgLKSWkVR5OxMMifWdqCb5MEg9k",
    authDomain: "licenses-refractive.firebaseapp.com",
    projectId: "licenses-refractive",
    storageBucket: "licenses-refractive.appspot.com",
    messagingSenderId: "607998273472",
    appId: "1:607998273472:web:27a629e60fccf9ade38a25",
    measurementId: "G-MBPE4J3FMN",
  },
};

const location = document.location.toString();
// Changes for the UAT Environment
if (location.includes("-beta")) {
  config = {
    ...config,

    features: {
      proToggle: true,
      buyPro: true,
      uatToggle: false,
    },
    title: config.title + ` - Beta`,
    id: config.id + `-beta`,
    environment: "beta",
  };
}

// Changes for the Dev Environment
if (location.includes("localhost") || location.includes("ngrok")) {
  config = {
    ...config,

    features: {
      proToggle: true,
      buyPro: true,
      uatToggle: true,
    },
    title: config.title + ` - DEV`,
    id: config.id + `-dev`,
    environment: "dev",
  };
}

export default config;

export function toggleUat() {
  if (config.features.uatToggle) {
    if (config.environment === "dev") {
      config.environment = "beta";
    } else {
      config.environment = "dev";
    }
  }
}
